export default "__VITE_ASSET__93afe00f__"